export default "/images/special-olympics.png";